import { CriticalEvent, Event } from "@cq/app/diagnostic/event";

export type AccountEventType =
  | "account-created"
  | "account-legacy-transfer"
  | "account-proceed-to-issue"
  | "account-submissions-created"
  | "account-quoted";

export class AccountEvent extends Event<AccountEventType> {}
export class CriticalAccountEvent extends CriticalEvent<AccountEventType> {}

export class AccountCreatedEvent extends AccountEvent {
  constructor() {
    super("account-created", "Account Created");
  }
}

export class AccountLegacyTransferEvent extends CriticalAccountEvent {
  constructor(platform: string) {
    super("account-legacy-transfer", `Legacy Transfer - ${platform}`, {
      platform,
    });
  }
}

export class AccountProceedToIssueEvent extends CriticalAccountEvent {
  constructor() {
    super("account-proceed-to-issue", "Proceed To Issue");
  }
}

type Submission = { policyTransactionId: string; productCode: string };

function mapSubmissionIdentifiers(submissions: Submission[]) {
  return submissions
    .map(
      (submission) =>
        `${submission.policyTransactionId}:${submission.productCode}`,
    )
    .join(" ");
}

export class AccountSubmissionsCreatedEvent extends AccountEvent {
  constructor(submissions: Submission[]) {
    const identifiers = mapSubmissionIdentifiers(submissions);
    super(
      "account-submissions-created",
      `Submissions Created - ${identifiers}`,
      {
        submissions,
      },
    );
  }
}

export class AccountQuotedEvent extends AccountEvent {
  constructor(submissions: Submission[]) {
    const identifiers = mapSubmissionIdentifiers(submissions);
    super("account-quoted", `Account Quoted - ${identifiers}`, {
      submissions,
    });
  }
}
